import React, { useContext, useEffect, useState } from 'react'
import BaseFilter from '../../../components/BaseFilter'
import {
  Grid,
  Box,
  Divider,
  IconButton,
  styled,
  TextField
} from '@mui/material'
import AdaptativeGridContainer from '../../../components/shared/AdaptativeGridContainer'
import { SyncAlt } from '@mui/icons-material'
import DefaultPainel from '../../../components/shared/Painel'
import Swal from 'sweetalert2'
import FormEmprestimo from '../../../components/forms/Emprestimo'
import Dater from '../../../services/DateFormat'
import TableHeader from '../../../components/shared/tables/TableHeader'
import gerarPaginacao from '../../../services/pagination.js'
import { Obras, Emprestimos } from '../../../services/http'
import BaseTooltip from '../../../components/BaseTooltip'
import BasicDatagrid from '../../../components/shared/tables/BasicDatagrid'
import getBibliotecario from '../../../services/http/user/getBibliotecario'
import SearchStartAdornment from '../../../components/adornment/SearchStartAdornment.js'
import SearchEndAdornment from '../../../components/adornment/SearchEndAdornment.js'
import MobileFilterHeaderContainer from '../../../components/filters/MobileFilterHeaderContainer.js'
import PrivateRC from '../../../components/PrivateRC.js'
import DevolverEmprestimo from './components/devolverEmprestimo.js'
import { PermissionsContext } from '../../../providers/permissions.js'

const StyledTextField = styled(TextField)(() => ({
  width: '100%'
}))

const LoanTable = styled(BasicDatagrid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('lg')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('xl')]: {
    height: '76vh'
  },
  '& .MuiDataGrid-cell': {
    textAlign: 'start',
    justifyContent: 'normal'
  }
}))

const Emprestimo = () => {
  const [tLoading, setTloading] = useState(false)
  const [query, setQuery] = useState({})
  const [books, setBooks] = useState([])
  const [queryLector, setQueryLector] = useState('')
  const [rows, setRows] = useState([])
  const [lastPage, setLastPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [filter, setFilter] = useState([])
  const { hasThisPermission } = useContext(PermissionsContext)

  const pagination = gerarPaginacao(
    true,
    lastPage,
    currentPage,
    (event, value) => getEmprestimos(query, value)
  )

  useEffect(() => {
    init()
    getBooks()
  }, [])

  // const getBooks = async () => {
  //   const { data } = await Obras().show({ per_page: -1 })
  //   setBooks(data.data)
  // }

  async function getBooks() {
    try {
      const { data } = await Obras().show({ per_page: -1 })
      setBooks(data.data)
    } catch (e) {
      console.error('Falha ao buscar obras', e)
    }
  }

  const baseColumn = {
    headerClassName: 'styledHeader',
    sortable: false
  }

  const columns = [
    {
      field: 'biblioteca',
      headerName: 'Biblioteca',
      flex: 1,
      ...baseColumn
    },
    {
      field: 'leitor',
      headerName: 'Leitor',
      flex: 2,
      ...baseColumn
    },
    {
      field: 'livro',
      headerName: 'Livro',
      flex: 4,
      ...baseColumn
    },
    {
      field: 'emprestimo',
      headerName: 'Data Empréstimo',
      flex: 1,
      ...baseColumn
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      ...baseColumn
    },
    hasThisPermission({ roles: 'bibliotecario' })
      ? {
          field: 'actions',
          headerName: 'Ações',
          flex: 1,
          ...baseColumn,
          renderCell: ({ row }) => (
            <DevolverEmprestimo row={row} execute={devolverLivro} />
          )
        }
      : {}
  ]

  const getEmprestimos = async (filters = {}, page = 1) => {
    setTloading(true)
    const { data } = await Emprestimos().show({
      page,
      ...filters,
      'includes[]':
        'leitor.user,leitor.biblioteca,exemplar.obra,statusEmprestimo',
      'orderBy[desc]': 'created_at'
    })

    setLastPage(data.last_page)
    setCurrentPage(data.current_page)
    const aux = data.data.map(item => ({
      ...item,
      biblioteca: item.leitor.biblioteca.apelido,
      leitor: item.leitor.user.name,
      livro: item.exemplar.obra.titulo,
      status: item.status_emprestimo.descricao,
      emprestimo: Dater().formatar(item.created_at, 'dd/mm/yyyy')
    }))
    setRows(aux)
    setTloading(false)
  }

  let typingTimer = ''

  const getLector = () => {
    setQuery(
      Object.assign(query, {
        'includes[leitor.user][name]': `%${queryLector?.toUpperCase()}%`
      })
    )
    getEmprestimos(query)
  }

  const handleClean = () => {
    if (queryLector !== '') {
      setQueryLector('')
      delete query['includes[leitor.user][name]']
      getEmprestimos({ ...query })
      return 0
    }
  }

  // const deleteLoan = async id => {
  //   await Emprestimos(id).delete(
  //     {},
  //     { notification: true, message: 'Livro devolvido com sucesso!' }
  //   )
  //   await getEmprestimos({}, currentPage)
  // }

  async function devolverLivro(id) {
    try {
      await Emprestimos(id).delete(
        {},
        { notification: true, message: 'Livro devolvido com sucesso!' }
      )
      await getEmprestimos({}, currentPage)
    } catch (e) {
      console.log(e)
    }
  }
  const init = async () => {
    const bibliotecario = await getBibliotecario()
    const arrayBibliotecas = []
    bibliotecario.map(item => arrayBibliotecas.push(item.biblioteca_id))

    setFilter([
      {
        service: {
          folder: 'obras',
          file: 'Obras',
          relationship: ''
        },
        query: {
          'includes[exemplares][biblioteca_id]': arrayBibliotecas.toString()
        },
        listLabel: 'obra',
        label: 'Obra',
        itemValue: 'id',
        itemText: 'titulo',
        id: 'includes[exemplar][obra_id]'
      },
      {
        service: {
          folder: 'bibliotecas',
          file: 'Bibliotecas',
          relationship: ''
        },
        listLabel: 'biblioteca',
        label: 'Biblioteca',
        itemValue: 'id',
        itemText: 'apelido',
        id: 'includes[leitor][biblioteca_id]'
      }
    ])

    const filterEmprestimos = hasThisPermission({ roles: 'bibliotecario' })
      ? { 'includes[exemplar][biblioteca_id]': arrayBibliotecas.toString() }
      : {}

    getEmprestimos(filterEmprestimos)
  }

  return (
    <Box>
      <PrivateRC roles="bibliotecario">
        <DefaultPainel sx={{ mt: '4vh' }}>
          <FormEmprestimo onSubmitEnd={() => getEmprestimos()} books={books} />
        </DefaultPainel>
      </PrivateRC>
      <DefaultPainel sx={{ mt: '4vh' }}>
        <AdaptativeGridContainer rowSpacing={0}>
          <>
            <TableHeader
              titulo="Lista de Empréstimos"
              controls={
                <PrivateRC roles="bibliotecario">
                  <MobileFilterHeaderContainer>
                    <StyledTextField
                      type="text"
                      color="white"
                      placeholder="Leitor"
                      size="small"
                      variant="outlined"
                      onKeyDown={() => {
                        clearTimeout(typingTimer)
                      }}
                      onKeyUp={() => {
                        clearTimeout(typingTimer)
                        typingTimer = setTimeout(getLector, 1000)
                      }}
                      onChange={({ target }) => {
                        setQueryLector(target.value)
                      }}
                      value={queryLector}
                      InputProps={{
                        style: { color: 'white' },
                        startAdornment: <SearchStartAdornment />,
                        endAdornment: (
                          <SearchEndAdornment
                            action={() => {
                              setQueryLector('')
                              handleClean()
                            }}
                          />
                        )
                      }}
                    />

                    <BaseFilter
                      color="white"
                      filter={filter}
                      onChange={value => {
                        setQuery(Object.assign(query, value))
                        getEmprestimos(query)
                      }}
                    />
                  </MobileFilterHeaderContainer>
                </PrivateRC>
              }
            />

            <Grid item xs={12} sm={12}>
              <Divider />
              <LoanTable
                loading={tLoading}
                rows={rows}
                columns={columns}
                disableColumnMenu
                pagination={pagination}
              />
            </Grid>
          </>
        </AdaptativeGridContainer>
      </DefaultPainel>
    </Box>
  )
}

export default Emprestimo
